import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal";

const ConfigProfileDSCPHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-settings-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="DSCP Profile settings"
      onClose={doClose}
      content={() => (
        <>
          <p>
          DSCP Profile. Match traffic of the specified list of DSCP code points:
          </p>
          <ul>
            <li>
              <b>CODE POINT</b>: DSCP code point number (integer between 0 and 63).
            </li>
            <li>
              <b>DIRECTION</b>: Traffic direction of packet with code point(downlink, uplink, uplink or downlink).
            </li>
          </ul>
          <p>
            Click on the edit{" "}
            <i className="material-icons valign-icon">edit</i> icon to
            edit an already configured profile entry.
          </p>
          <p>
            Click on the delete{" "}
            <i className="material-icons valign-icon">delete</i> icon to
            delete a single profile entry.
          </p>
          <p>
            Press the <i className="material-icons valign-icon">more_vert</i>{" "}
            icon and then select the <b>Add Code Point...</b> option to add a new code point to the profile..
          </p>
        </>
      )}
    />
  );
};

export default ConfigProfileDSCPHelpModal;
